import { BaseBlock } from "./BaseBlock";

type Product = {

    state:
        | "active"
        | "recoverable"
        | "never_subscribed";

    remaining_new_kroks: number;

};

export class ProductStateBlock extends BaseBlock {

    private readonly product: Product;

    private root!: HTMLElement;

    constructor(
        product: Product
    ) {

        super();

        this.product = product;

    }

    public override mount(): void {

        this.root =
            this.buildRoot();

    }

    public override update(): void {

        const newRoot =
            this.buildRoot();

        this.root.replaceWith(
            newRoot
        );

        this.root =
            newRoot;

    }

    public getRoot(): HTMLElement {

        return this.root;

    }

    // =========================

    private buildRoot(): HTMLElement {

        const root =
            document.createElement("div");

        switch (this.product.state) {

            case "active": {

                root.innerHTML = `
                    <p>
                        Залишок доступних нових кроків на зараз:
                        <b>${this.product.remaining_new_kroks}</b>
                    </p>
                `;

                break;

            }

            case "recoverable": {

                root.innerHTML = `
                    <p>
                        Підписка завершилась
                    </p>
                `;

                break;

            }

            case "never_subscribed": {

                root.innerHTML = `
                    <p>
                        Ви не маєте діючої підписки
                    </p>
                `;

                break;

            }

        }

        return root;

    }

}